import { DownloadService } from './../_services/download.service';
import { ApiPathsService } from './../../api-paths.service';
import { HttpParams } from '@angular/common/http';
import { ApiRestService } from './../_services/api-rest.service';
import { FileStoreService } from '../_services/file-store.service';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ɵConsole} from '@angular/core';
import { Files } from '../models/File';
import { AngularFileUploaderComponent } from './angular-file-uploader.component';
import { AngularFileUploaderConfig } from './angular-file-uploader.types'
import { Subscription } from 'rxjs';
import { error } from 'protractor';
import {Permission} from "../../Login/_guards/Permission";

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html'
})
export class FileUploaderComponent implements OnInit {
  @Output() onFileSaved = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Input() CanDelete: boolean = true;
  @Output() CanDeleteChange = new EventEmitter();
  private subscriptions: Subscription = new Subscription();
  @ViewChild('fileUpload')
    private fileUpload:  AngularFileUploaderComponent;
  url: string = "";
  listafile: Files[];
  descrizione: string = "";
  id: string;
  parametri: HttpParams = new HttpParams();
  @Input() HideListaFile : boolean
  @Output() Base64FilesChange = new EventEmitter<{allegato: string, file: string, descrizione: string}[]>();
  @Input()  afuConfig: AngularFileUploaderConfig = {
    multiple: false,
    maxSize: 5,
    formatsAllowed: "pdf,doc,docx,xls,xlsx,jpg,png,txt,ods,odt",
    uploadAPI:  {
      url: this.url,
      method: "POST",
      headers: this.apirest.headerforfile(),
      //responseType: 'application/json',
    },
    paramsType: "body",
    theme: "dragNDrop",
    hideProgressBar: false,
    hideResetBtn: false,
    hideSelectBtn: false,
    hideUploadButton: true,
    hideExternalUploadButton: false,
    fileNameIndex: true,
    replaceTexts: {
      selectFileBtn: 'Seleziona il File',
      resetBtn: 'Reset',
      uploadBtn: 'Carica',
      dragNDropBox: 'TRASCINA QUI IL FILE',
      attachPinBtn: 'Attach Files...',
      afterUploadMsg_success: 'Successfully Uploaded !',
      afterUploadMsg_error: 'Upload Failed !',
      sizeLimit: 'Size Limit'
    }
  };
  collectionSize: number = 0;
  Base64Files: { allegato: string; file: string; descrizione: string }[];
  constructor(
    private fileStore: FileStoreService,
    private apirest: ApiRestService,
    public apipathsservice: ApiPathsService,
    private downloadService: DownloadService,
    public permission: Permission
  ) {
  }
  ngOnInit() {
    this.subscriptions.add(this.fileStore.$url.subscribe(data => {
      this.url = data;
      this.afuConfig.uploadAPI.url = this.url;
    }));
    this.subscriptions.add(this.fileStore.$id.subscribe(valore => this.id = valore ));
    this.subscriptions.add(this.fileStore.$listaFile.subscribe(data => {
      this.listafile = data
      this.collectionSize = data?.length ?? 0;
    }));
   }
  delete(file) {
    if (confirm("Sei sicuro di voler eliminare questo file?"))
    this.fileStore.deleteFile(file).subscribe((data) => {
      this.onChange.emit(data);
    });
  }
  download(file: Files) {
    console.log("download",file.id);
    this.apirest.downloadFle(file.id).subscribe(data => {
      this.downloadService.downloadFile(data,file.file)
    });
  }
  onResetClick() {
    this.descrizione = "";
  }
  DocUploaded(event) {
    this.onFileSaved.emit(event);
    this.onChange.emit(event);
  }
  descrizioneCambiata() {
    if (this.afuConfig.paramsType == 'base64Array' && this.Base64Files?.length>0) {
      this.Base64Files.forEach(value => value.descrizione = this.descrizione);
      this.Base64FilesChange.emit(this.Base64Files);
    }
    console.log(this.descrizione);
  }
  Save() {
    this.fileUpload.uploadFiles({ 'id': this.id, 'descrizione': this.descrizione });
  }

  Base64FilesOnChange(event: {allegato: string; file: string; descrizione: string}[]) {
    this.Base64Files = event;
    this.Base64FilesChange.emit(this.Base64Files);
  }
}
